module.exports = __webpack_public_path__ + "static/media/015.444f733a.jpg";